import { Grid, TextField, Typography, MenuItem, FormControlLabel, Checkbox, Tooltip, InputAdornment, Popper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from 'react-hook-form';
import React, { useState, useEffect, Fragment } from 'react';
import { fieldDimensionOptions, hyperlinkOptions, hyperlinkTypes } from '../../../config/common';
import { validationMessages, basicFolderFileName, requiredOnly, requiredOnlyMessage, patternOnly, patternOnlyMessage, typeSpecificValidation, integerFloatCheck, variableBasic } from '../../../config/validations';
import {
  createDefaultNestedFieldsForChartBarLine,
  createDefaultNestedFieldsForChartGeomap,
  createDefaultNestedFieldsForChartPie,
  createDefaultNestedFieldsForVideo,
  createNestedFieldsForControls,
  createDefaultNestedFieldsForImage,
  createDefaultNestedFieldsForURLExternal,
  createDefaultNestedFieldsForURLClusterlet,
  createDefaultNestedFieldsForURLView,
  createDefaultNestedFieldsForModel3D,
  createDefaultNestedFieldsForScene3D,
  createDefaultNestedFieldsForCompass,
  createDefaultNestedFieldsForChartPieRadial,
  createDefaultNestedFieldsForRatioBarChart,
  createDefaultNestedFieldsForStackBarChart,
  createDefaultNesterFieldsForGauge,
  createDefaultNestedFieldsForRangePlot,
  createDefaultNestedFieldsForHeatmap,
  findMessageTypes
} from '../../../services/entities/fields';
import {
  typeItems,
  defaultValueTypes,
  minValueTypes,
  maxValueTypes,
  unitTypes,
  dropdownTypes,
  dimensionTypes,
  axisTypes,
  validationTypes,
  minValueTypesForEventType,
  maxValueTypesForEventType,
  typesForFieldsWithParentChartType,
  visibleTypes,
  controlTypes,
  otherDisplayTypes,
  urlTypes,
  urlItems,
  typesForFieldsWithParentMapType,
  axisTypesForMap,
  iconTypes,
  hyperlinkSupportedTypes,
  orientationTypes,
  hyperlinkNotRequiredType,
  colorSupportedTypes,
  mediaTypes,
} from '../../../config/fields';
import { booleanOptions, axisOptions, orientationOptions, lineTypeOptions } from '../../../config/common';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';
import DateTimePickerField from '../../atoms/Wrappers/dateTimePicker';
import { formatDateTime } from '../../../services/entities/fields';
import ListSubheader from '@material-ui/core/ListSubheader';
import { invokeGetService, invokePostService, setExpanded, setReRender } from '../../../store/global/actions';
import { getFirstOrderEvents } from '../../../services/blueprint';
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { Autocomplete } from '@material-ui/lab';
import { validateNonAsciiChars } from '../../../utils/commonUtils';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader';
import { getElementOnFocus } from '../../../store/global/selectors';

const shortUUiD = require('short-uuid');

export default function EditField({ onClose, onCompletion, fields, parentDT, isEventType, messageId }) {
  const dispatch = useDispatch();
  const elementOnFocus = useSelector(getElementOnFocus);

  const [sectionList, setSectionList] = useState([]);
  const [fieldList, setFieldList] = useState([]);
  const [messageList, setMessageList] = useState([]);
  const [clusterletList, setClusterletList] = useState([]);
  const [allEvents, setAllEvents] = useState([]);
  const [selectedField, setSelectedField] = useState(fields.item);
  const [loading, setLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [rootElement, setRootElement] = useState(null);
  const [filteredTypeItems, setFilteredTypeItems] = useState([]);
  const [immediateParentType, setImmediateParentType] = useState('');
  const [defaultDate, setDefaultDate] = useState(null);
  const [dateStatus, setDateStatus] = useState(true);
  const [profile, setProfile] = useState(false);
  const [displayTypes, setDisplayTypes] = useState([...otherDisplayTypes, ...urlItems]);
  const [isParentFieldTypeTable, setIsParentFieldTypeTable] = useState(false);
  const [viewsNames, setViewsNames] = useState([]);
  const [clusterletNames, setClusterletNames] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [delegates, setDelegates] = useState([]);
  const [nestedTransactions, setNestedTransactions] = useState([]);
  const [messageTypes, setMessageTypes] = useState([]);
  const [bgcolor, setBgcolor] = useState("#ffffff");
  const [textcolor, setTextcolor] = useState("#34495e");
  const [allowMultiline, setAllowMultiline] = useState(fields?.item?.attributes?.inputtype === "textarea" ? true : false);

  let root = '';
  let parentClusterlet;
  let parentSection;

  const name = selectedField.name;
  const { desc, type, collection, target, dropdown, optional, maxval, minval, unit, axis, dimensions, validation, visible, event, orientation, step, linetype, icon, viewname, clusterlettype, instance, url, transaction, constraint, inputtype} = selectedField.attributes || {};

  const allowMultilineDefault = (inputtype && inputtype === "textarea") ? true : false 
  // setAllowMultiline((inputtype && inputtype === "textarea") ? true : false );

  let height = '';
  let width = '';
  if (dimensions) {
    const dimensionSplit = dimensions.split('x');
    width = dimensionSplit[0];
    height = dimensionSplit[1];
  }
  const defaultVal = selectedField?.attributes?.default;

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
    getValues,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      name,
      desc,
      type: type === 'DOUBLE' ? type.toLowerCase() : type,
      allowMultiline: allowMultiline || false,  
      collection,
      dropdown,
      target,
      optional,
      maxval,
      minval,
      unit,
      axis,
      height,
      width,
      validation,
      visible,
      event,
      orientation,
      defaultVal,
      step,
      linetype,
      constraint,
    },
    shouldUnregister: false,
  });

  let typeOfField = watch('type');
  const watchHeight = watch('height');
  const watchWidth = watch('width');
  const selectedTransaction = watch('transaction');

  const [fieldParent, setFieldParent] = useState(null);


  // console.log({
  //   selectedField,
  //   inputtype,
  //   allowMultilineDefault,
  //   optional
  // })


  useEffect(() => {
    if (typeIntItems.includes(typeOfField)) setValue('defaultVal', 0);
    if (stringTypes.includes(typeOfField)) setValue('defaultVal', '');
    if (typeOfField === 'BOOL') setValue('defaultBoolVal', false);
  }, [typeOfField]);

  useEffect(() => {
    setIsFetching(true);

    Promise.all([
      dispatch(invokeGetService('getField', [fields.id])),
      dispatch(invokeGetService('getBlueprintConstructs', []))
    ]).then(([res, constructsResponse]) => {

      if (res?.status) {
        const sectionsArray = res?.data?.sections ? res?.data?.sections : [];
        const eventsArray = res?.data?.events ? res?.data?.events : [];
        const clusterletsArray = res?.data?.clusterlets ? res?.data?.clusterlets : [];
        const messagesArray = res?.data?.messages ? res?.data?.messages : [];
        const fieldsArray = res?.data?.fields ? res?.data?.fields : [];
        const firstOrderEvents = getFirstOrderEvents(eventsArray, clusterletsArray);
        const viewNames = res?.data?.views ? res?.data?.views : [];
        const clusterletNames = res?.data?.clusterlets ? res?.data?.clusterlets.filter((item) => item.type == 2 || item.type == 3) : [];
        const filteredTransactions = constructsResponse?.data?.transactions ? constructsResponse?.data?.transactions.filter(tr => tr.type == 7) : [];

        setTransactions(filteredTransactions);
        setNestedTransactions(constructsResponse?.data?.transactions ? constructsResponse?.data?.transactions.filter(tr => !(tr.type == 7)) : [])
        setViewsNames(viewNames);
        setClusterletNames(clusterletNames);
        setSectionList(sectionsArray);
        setClusterletList(clusterletsArray);
        setMessageList(messagesArray);
        setFieldList(fieldsArray);
        setAllEvents(eventsArray);
        setSelectedField(res?.data?.selectedField);
        const fieldbgcolor = res?.data?.selectedField?.attributes?.bgcolor ? res?.data?.selectedField?.attributes?.bgcolor : "#ffffff";
        const fieldtextcolor = res?.data?.selectedField?.attributes?.textcolor ? res?.data?.selectedField?.attributes?.textcolor : "#34495e";
        setBgcolor(fieldbgcolor);
        setTextcolor(fieldtextcolor);
        setDelegates(res?.data.clusterlets ? res?.data.clusterlets.filter(item => item.type == 1) : []);
      } else {
        if (res?.code === 255) {
          onClose();
        }
      }
      setIsFetching(false);

    }).catch(err => {
      console.error("Error: ", err)
    })
  }, []);

  useEffect(() => {
    findRootElement(selectedField);
    if (root) {
      setRootElement(root);
      if (root === 'eventType') {
        const filteredTypes = typeItems.filter(item => !typesNotInEventType.includes(item.value));
        const sortedTypes = [...filteredTypes, ...mediaTypes].sort((a, b) => a.value.toLowerCase() > b.value.toLowerCase() ? 1 : -1);
        setFilteredTypeItems(sortedTypes);
      } else if (selectedFieldParent?.attributes?.type === 'table') {
        setIsParentFieldTypeTable(true);
        setFilteredTypeItems([...typeItems]);
        setDisplayTypes([...urlItems]);
      } else if (selectedFieldParent?.attributes?.type === 'chart-rangeplot' || selectedFieldParent?.attributes?.type === 'chart-geomap') {
        setFilteredTypeItems([...typeItems]);
      } else {
        axisTypes.includes(selectedFieldParent?.attributes?.type)
          ? setFilteredTypeItems(typeItems.filter((item) => typesForFieldsWithParentChartType.includes(item.value)))
          : axisTypesForMap.includes(selectedFieldParent?.attributes?.type)
            ? setFilteredTypeItems(typeItems.filter((item) => typesForFieldsWithParentMapType.includes(item.value)))
            : setFilteredTypeItems(parentDT ? typeItems : typeItems.filter(item => item.value !== 'table-button'));
      }
    }
    if (defaultVal !== undefined && type === typeOfField) setValue('defaultVal', defaultVal);
    if (defaultVal !== undefined && type === 'BOOL') setValue('defaultBoolVal', defaultVal);

    const immediateParent = fieldList.find((item) => item._id === selectedField.parent[0].id)
      ? fieldList.find((item) => item._id === selectedField.parent[0].id)
      : sectionList.find((item) => item._id === selectedField.parent[0].id)
        ? sectionList.find((item) => item._id === selectedField.parent[0].id)
        : messageList.find((item) => item._id === selectedField.parent[0].id);
    if (immediateParent?.type === 12) setImmediateParentType(immediateParent?.attributes?.type);

    if (immediateParent?.attributes?.type === 'table') {
      setDisplayTypes([...urlItems]);
      setFilteredTypeItems([...typeItems]);
    } else {
      setDisplayTypes([...otherDisplayTypes, ...urlItems]);
    }
  }, [selectedField, fieldList]);

  const typesNotInEventType = ['counter', 'gauge', 'table', 'chart-geomap', 'chart-bar', 'chart-line', 'TimeStamp', 'DateTime', 'video', 'display', 'url-external', 'url-clusterlet', 'url-view', 'model-3d', 'table-button'];
  let selectedFieldParent = fieldList.find((item) => item._id === selectedField.parent[0].id)
    ? fieldList.find((item) => item._id === selectedField.parent[0].id)
    : messageList.find((item) => item._id === selectedField.parent[0].id)
      ? messageList.find((item) => item._id === selectedField.parent[0].id)
      : sectionList.find((item) => item._id === selectedField.parent[0].id);
      selectedFieldParent = selectedFieldParent ? selectedFieldParent : {};
  const hyperlinkOptionValue = viewname != undefined || clusterlettype != undefined || url != undefined ? 'enable' : 'disable';
  const hyperlinkTypeDefault = viewname != undefined ? 'urlView' : clusterlettype != undefined ? 'urlClusterlet' : url != undefined ? 'urlExternal' : '';
  const typeDateItems = ['DateTime', 'TimeStamp'];
  let children = [];
  const numberTypes = ['gauge', 'FLOAT', 'DOUBLE', 'double'];
  const structTable = ['struct', 'table'];
  const lineBarCharts = ['chart-bar', 'chart-line', 'chart-ratiobar'];
  const stringTypes = ['OCTETSTRING', 'string'];
  const typeIntItems = ['UINT8', 'UINT16', 'UINT32', 'UINT64', 'INT8', 'INT16', 'INT32', 'INT64', 'DOUBLE', 'FLOAT', 'counter', 'double'];
  const multilineInputSupportedTypes = ["string", "OCTETSTRING"];
  const numberCheck = new RegExp(/^\-?[0-9]\d*(\.\d*)?$/).test(defaultVal);
  const dateTimeCheck = new RegExp(/^([0-9]{4})-([0-1][0-9])-([0-3][0-9])\s([0-1][0-9]|[2][0-3]):([0-5][0-9]):([0-5][0-9])$/).test(defaultVal);
  const typeBeforeEdit = selectedField?.attributes?.type;
  const constraintNotSupportedTypes = ["struct", ...messageTypes?.map(item => item?._id)];


  // console.log("selected transaction: ", selectedTransaction)

  // watching change in the hyperlink options
  let hyperlinkOption = watch('hyperlink');
  hyperlinkOption = hyperlinkOption === undefined ? hyperlinkOptionValue : hyperlinkOption;
  const selectedHyperlinkType = watch('hyperlinkType', hyperlinkTypeDefault);

  const findRootElement = (selectedItem) => {
    const element = fieldList.find((item) => item._id === selectedItem._id || item._id === selectedItem.id);
    const parentId = element?.parent?.[0]?.id;
    const parent = fieldList.find((item) => item._id === parentId) ? fieldList.find((item) => item._id === parentId) : sectionList.find((item) => item._id === parentId) ? sectionList.find((item) => item._id === parentId) : messageList.find((item) => item._id === parentId);

    if (parent?.type === 17) {
      root = 'eventType';
      const filteredMessages = messageList.filter(item => item._id != parent._id);
      setMessageTypes(findMessageTypes(filteredMessages, fieldList));
      setFieldParent(parent);
    } else if (parent?.type === 11) {
      root = 'property';
      setFieldParent(parent);
      parentSection = parent;
      parentClusterlet = clusterletList?.find((item) => item._id === parent.parent[0].id);
      if (parentClusterlet.type === 6) setProfile(true);
    } else {
      if (element && element.parent && element.parent[0]) {
        findRootElement(element.parent[0]);
      }
    }
  };

  const renderDefaultValue = defaultValueTypes.includes(typeOfField) ? true : false;
  const renderMinValue = (minValueTypes.includes(typeOfField) && rootElement === 'property') || (minValueTypesForEventType.includes(typeOfField) && rootElement === 'eventType') ? true : false;
  const renderMaxValue = (maxValueTypes.includes(typeOfField) && rootElement === 'property') || (maxValueTypesForEventType.includes(typeOfField) && rootElement === 'eventType') ? true : false;
  const renderUnitValue = unitTypes.includes(typeOfField) && rootElement === 'property' ? true : false;
  const renderdropdownValue = dropdownTypes.includes(typeOfField) && rootElement === 'property' && profile === true ? true : false;
  const renderDimensionValue = dimensionTypes.includes(typeOfField) ? true : false;
  const renderCollectionValue = typeOfField && rootElement === 'eventType' ? true : false;
  const renderValidationValue = validationTypes.includes(typeOfField) && rootElement === 'eventType-updated-when-validation-needed' ? true : false;
  const renderDatePicker = typeDateItems.includes(typeOfField) ? true : false;
  const renderBooleanDefaultValue = typeOfField === 'BOOL' ? true : false;
  const renderVisibilityValue = (visibleTypes.includes(typeOfField) && parentDT === true) || immediateParentType === 'table' ? true : false;
  const renderOptionalValue = rootElement === 'eventType' ? true : false;
  const renderDisplayTypes = dimensionTypes.includes(typeOfField) && parentDT === true ? true : false;
  const renderControlTypes = controlTypes.includes(typeOfField) && parentDT === true ? true : false;
  const renderOrientation = orientationTypes.includes(typeOfField);
  const disableDisplayOptions = rootElement === 'eventType' ? false : true;
  const renderStep = typeOfField === 'control-slider' ? true : false;
  const renderaxisValue = selectedFieldParent.type === 12 && [...axisTypes].includes(selectedFieldParent?.attributes?.type) ? true : false;
  const renderlineType = typeOfField === 'chart-line' ? true : false;
  const renderIconType = typeOfField === 'counter' ? true : false;
  const renderConstraint = rootElement === 'eventType' && !constraintNotSupportedTypes?.includes(typeOfField) ? true : false;
  const renderMultilineInputCheckbox = profile === true && multilineInputSupportedTypes.includes(typeOfField) ? true : false;


  const parentOfSelectedFieldParent = fieldList.find(field => field._id == selectedFieldParent?.parent?.[0]?.id);

  const isHyperlinkRequired = hyperlinkNotRequiredType.includes(typeOfField) ? false : true; 
  const renderHyperlink = (isParentFieldTypeTable && !urlTypes.includes(typeOfField) && isHyperlinkRequired && !(parentOfSelectedFieldParent?.attributes?.type === "table")) || hyperlinkSupportedTypes.includes(typeOfField);


  const renderColorForString = !isParentFieldTypeTable ? true : false;
  const renderColorPicker = profile === false && colorSupportedTypes?.includes(typeOfField) && renderColorForString && rootElement !== 'eventType' ? true : false;

  const handleChange = (value) => {
    value == 'Invalid Date' ? setDateStatus(false) : setDateStatus(true);
    const formattedDate = value !== null ? formatDateTime(value) : null;
    setDefaultDate(formattedDate);
  };

  const onUpdate = ({
    name,
    desc,
    type,
    collection,
    dropdown,
    target,
    optional,
    maxval,
    minval,
    unit,
    axis,
    dimensions,
    height,
    width,
    defaultVal,
    validation,
    visible,
    event,
    orientation,
    defaultBoolVal,
    step,
    linetype,
    iconType,
    hyperlink,
    hyperlinkType,
    viewname,
    clusterlettype,
    instance,
    url,
    transaction,
    errorResponseEvents, 
    constraint,
    allowMultiline
  }) => {
    setLoading(true);
    
    const mandatoryCollectionTypes = ['table'];

    const fieldDataFormat = {
      name: name,
      type: selectedField.type,
      parent: selectedField.parent,
      attributes: {},
    };

    /**by default */
    if (type === 'struct' && rootElement === 'property') fieldDataFormat.attributes.collection = false;

    if (typeOfField === 'table' && rootElement === 'property') fieldDataFormat.attributes.collection = true;

    if (mandatoryCollectionTypes.includes(type) == false) {
      delete fieldDataFormat?.attributes?.collection;
    }

    if (desc !== '' && desc !== undefined) fieldDataFormat.attributes.desc = desc;
    if (type !== '' && type !== undefined && type != 'display') fieldDataFormat.attributes.type = type;
    if (collection !== '' && collection !== undefined) fieldDataFormat.attributes.collection = collection
    if (dropdown !== '' && dropdown !== undefined) fieldDataFormat.attributes.dropdown = dropdown;
    if (target !== '' && target !== undefined) fieldDataFormat.attributes.target = target;
    if (optional !== '' && optional !== undefined) fieldDataFormat.attributes.optional = optional;
    if (maxval !== '' && maxval !== undefined) fieldDataFormat.attributes.maxval = maxval;
    if (minval !== '' && minval !== undefined) fieldDataFormat.attributes.minval = minval;
    if (unit !== '' && unit !== undefined) fieldDataFormat.attributes.unit = unit;
    if (axis !== '' && axis !== undefined) fieldDataFormat.attributes.axis = axis;
    if (defaultVal !== '' && defaultVal !== undefined && typeOfField !== 'BOOL') fieldDataFormat.attributes.default = defaultVal;
    if (defaultBoolVal !== undefined && typeOfField === 'BOOL') fieldDataFormat.attributes.default = defaultBoolVal;
    if (validation !== '' && validation !== undefined) fieldDataFormat.attributes.validation = validation;
    if (typeDateItems.includes(type) && defaultDate !== undefined) fieldDataFormat.attributes.default = defaultDate;
    if (visible !== '' && visible !== undefined) fieldDataFormat.attributes.visible = visible;
    if (orientation !== undefined && orientation !== '') fieldDataFormat.attributes.orientation = orientation;
    if (step !== undefined && step !== '') fieldDataFormat.attributes.step = Number(step);
    if (linetype !== undefined && linetype !== '') fieldDataFormat.attributes.linetype = linetype;
    if (iconType !== undefined && iconType !== '') fieldDataFormat.attributes.icon = iconType;
    if (renderMultilineInputCheckbox && allowMultiline !== undefined && allowMultiline === true) fieldDataFormat.attributes.inputtype = "textarea";


    //dimensions
    if (height !== '' && height !== undefined && width !== '' && width !== undefined) {
      fieldDataFormat.attributes.dimensions = `${width}x${height}`;
    }

    if (!dateStatus) {
      return false;
    }

    if (typeOfField === 'counter') fieldDataFormat.attributes.infotype = 'numeric';

    if (typeOfField === 'model-3d') {
      fieldDataFormat.attributes.infotype = 'numeric';
      fieldDataFormat.attributes.position = '+0+0';
    }

    if ( rootElement !== 'eventType' && typeOfField !== typeBeforeEdit && !(structTable.includes(typeOfField) && structTable.includes(typeBeforeEdit)) && !(lineBarCharts.includes(typeOfField) && lineBarCharts.includes(typeBeforeEdit))) {
      if (typeOfField === 'chart-geomap') {
        children = createDefaultNestedFieldsForChartGeomap(fieldDataFormat);
      } else if (typeOfField === 'chart-bar' || typeOfField === 'chart-line' || typeOfField === 'chart-scatter') {
        children = createDefaultNestedFieldsForChartBarLine(fieldDataFormat);
      } else if (typeOfField === 'chart-ratiobar') {
        children = createDefaultNestedFieldsForRatioBarChart(fieldDataFormat);
      } else if (typeOfField === 'chart-stackbar') {
        children = createDefaultNestedFieldsForStackBarChart(fieldDataFormat);
      } else if (typeOfField === 'chart-pie') {
        children = createDefaultNestedFieldsForChartPie(fieldDataFormat);
      } else if (typeOfField === 'video') {
        children = createDefaultNestedFieldsForVideo(fieldDataFormat);
      } else if (typeOfField === 'image') {
        children = createDefaultNestedFieldsForImage(fieldDataFormat);
      } else if (typeOfField === 'url-external') {
        children = createDefaultNestedFieldsForURLExternal(fieldDataFormat);
      } else if (typeOfField === 'url-clusterlet') {
        children = createDefaultNestedFieldsForURLClusterlet(fieldDataFormat);
      } else if (typeOfField === 'url-view') {
        children = createDefaultNestedFieldsForURLView(fieldDataFormat);
      } else if (typeOfField === 'model-3d') {
        children = createDefaultNestedFieldsForModel3D(fieldDataFormat);
      } else if (type === 'scene-3d') {
        children = createDefaultNestedFieldsForScene3D(fieldDataFormat);
      } else if (type === 'compass') {
        children = createDefaultNestedFieldsForCompass(fieldDataFormat);
      } else if (type === 'chart-pie-radial') {
        children = createDefaultNestedFieldsForChartPieRadial(fieldDataFormat);
      } else if (type === 'gauge') {
        children = createDefaultNesterFieldsForGauge();
      } else if (type === 'chart-rangeplot') {
        children = createDefaultNestedFieldsForRangePlot(fieldDataFormat);
      } else if (type === 'chart-heatmap') {
        children = createDefaultNestedFieldsForHeatmap(fieldDataFormat);
      } else if (controlTypes.includes(typeOfField)) {
        children = createNestedFieldsForControls(fieldDataFormat);
      }
    }

    // control UI types
    if (controlTypes.includes(typeOfField)) {
      if (transaction !== undefined && transaction !== '') fieldDataFormat.attributes.transaction = transaction;
      if (instance !== undefined && instance !== '') fieldDataFormat.attributes.instance = instance;
      if (transaction !== undefined && transaction !== '' && errorResponseEvents != undefined && errorResponseEvents.length > 0) {
        if (Array.isArray(errorResponseEvents)) {
          fieldDataFormat.attributes.error_response_events = errorResponseEvents;
        } else if (typeof errorResponseEvents === "string") {
          fieldDataFormat.attributes.error_response_events = [errorResponseEvents];
        }
      }
    }

    // hyperlink attributes adding to the payload
    if (hyperlink != undefined && hyperlink == 'enable' && (hyperlinkSupportedTypes.includes(typeOfField) || (isParentFieldTypeTable && !urlTypes.includes(typeOfField) ? true : false))) {
      if (hyperlinkType != undefined && hyperlinkType == 'urlView') {
        if (viewname != undefined) fieldDataFormat.attributes.viewname = viewname;
        if (instance != undefined) fieldDataFormat.attributes.instance = instance;
      }

      if (hyperlinkType != undefined && hyperlinkType == 'urlClusterlet') {
        if (clusterlettype != undefined) fieldDataFormat.attributes.clusterlettype = clusterlettype;
        if (instance != undefined) fieldDataFormat.attributes.instance = instance;
      }

      if (hyperlinkType != undefined && hyperlinkType == 'urlExternal') {
        if (url != undefined) fieldDataFormat.attributes.url = url;
      }
    }

    if(renderColorPicker && colorSupportedTypes?.includes(typeOfField) && bgcolor && textcolor){
      fieldDataFormat.attributes.textcolor = textcolor;
      fieldDataFormat.attributes.bgcolor = bgcolor;
    }

    if(!constraintNotSupportedTypes.includes(type) && constraint !== undefined){
      fieldDataFormat.attributes.constraint = constraint;
    }

    if (fieldDataFormat?.attributes?.default == null) delete fieldDataFormat.attributes.default;

    fieldDataFormat.children = children;

    let payload = {
      field: fieldDataFormat, 
      eventType: rootElement === 'eventType' ? true : false
    }
    if(messageId){
      payload.messageId  = messageId
    }

    payload.rootParent = elementOnFocus.id;
    payload.rootParentType = elementOnFocus.type;

    dispatch(invokePostService('editField', payload, [fields.id])).then((res) => {
      setLoading(false);
      if (res?.status) {
        const errors = res?.data?.validationErrors ? res?.data?.validationErrors : [];
        if (selectedField !== undefined && selectedField.parent[0] !== undefined) dispatch(setExpanded(selectedField.parent[0].id))

        if(isEventType) dispatch(setReRender());

        onCompletion('Field', 'edit', errors, undefined, {...fieldDataFormat, _id: fields.id});
      } else {
        if (res?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
          res?.errors?.forEach((error) => {
            setError(error.name, { message: error.message });
          });
        }
        if (res?.code === 255) {
          onClose();
        }
      }
    });
  };
  const messages = { ...validationMessages, ...patternOnlyMessage, ...requiredOnlyMessage, validate: 'This section name is already used' };

  const handleBgcolorChange = (e) => {
    setBgcolor(e.target.value)
  }
  const handleTextcolorChange = (e) => {
    setTextcolor(e.target.value)
  }

  return (
    <>
      {isFetching === true ? (
        <SkeletonLoader type="form" rows={6} />
      ) : (
        <Grid id={"edit_field_form"} container direction={'row'} spacing={3}>
          <Grid item xs={12} style={{ marginTop: 10 }}>
            <Typography>Edit field</Typography>
          </Grid>

          {/* {rootElement === 'eventType' && <Grid item xs={12}>
                        <ReusedFieldWarning message={fieldParent} />
                    </Grid>} */}

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isEventType ? '2fr 1fr' : '1fr',
              padding: '0 12px',
              gap: '12px',
              width: '100%'
            }}
          >
            <Grid item xs={12}>
              <TextField
                name="name"
                fullWidth
                type={'text'}
                required={true}
                label={'Name'}
                variant="outlined"
                placeholder={'Name'}
                inputRef={register({ ...variableBasic })}
                error={errors?.name ? true : false}
                helperText={errors?.name ? (errors?.name?.message ? errors?.name?.message : messages[errors?.name?.type]) : ''}
              />
            </Grid>
            {renderOptionalValue && isEventType && (
              <Grid item xs={12}>
                <Controller
                  name="optional"
                  control={control}
                  render={({ field, onChange }) => (
                    <FormControlLabel
                      control={
                        <Checkbox
                          {...field}
                          onChange={e => {
                            onChange(e.target.checked)
                            setSelectedField(prev => ({ ...prev, attributes: { ...prev.attributes, optional: e.target.checked } }))
                          }}
                          name="optional"
                          id="optional"
                          color="primary"
                          checked={optional}
                        />
                      }
                      label="Optional Field"
                    />
                  )}
                />
              </Grid>
            )}
          </div>

          <Grid item xs={12}>
            <TextField 
              id="desc" 
              type={'text'} 
              fullWidth 
              rows={4} 
              label={'Description'} 
              placeholder={'Description'} 
              variant="outlined" 
              name="desc" 
              inputRef={register({ required: false, validate: validateNonAsciiChars})} 
              error={errors?.desc} 
              helperText={errors?.desc?.message || ''}
              multiline={true} 
              minRows={2} 
            />
          </Grid>

          <Grid item xs={12}>
           {!isEventType && <Controller
              name="type"
              control={control}
              defaultValue={type}
              rules={{ required: true, requiredOnly }}
              render={({ field, value, onChange }) => (
                <TextField
                  {...field}
                  label={'Type'}
                  name="type"
                  select
                  required
                  fullWidth
                  variant={'outlined'}
                  onChange={(e) => {
                    onChange(e);
                  }}
                  value={value}
                  error={errors?.type ? true : false}
                  helperText={messages[errors?.type?.type] || ''}>
                  <MenuItem key={123} value={''}>
                    Select
                  </MenuItem>
                  {disableDisplayOptions && parentDT && (selectedFieldParent.type == 11 || selectedFieldParent?.attributes?.type === 'table') && <ListSubheader disableSticky={true}>Display widgets</ListSubheader>}
                  {disableDisplayOptions &&
                    parentDT &&
                    (selectedFieldParent.type == 11 || selectedFieldParent?.attributes?.type === 'table') &&
                    displayTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  {profile === false && <ListSubheader disableSticky={true}>Universal types</ListSubheader> } 
                  {filteredTypeItems.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.title}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />}
             {isEventType &&
                     <Controller
                     name="type"
                     control={control}
                     rules={{ required: true }}
                     defaultValue={type}
                     render={({ field, value, onChange }) => {
                       const optionsWithSubheader = [
                         { title: 'Universal types', group: 'universalTypes', subheader: true, disabled: true, value: "#" },
                         ...filteredTypeItems,
                         { title: 'Messages', group: 'Messages', subheader: true, disabled: true },
                         ...messageTypes,
                       ];
                   
                       return (
                         <Autocomplete
                           {...field}
                           name="type"
                           options={optionsWithSubheader}
                           PopperComponent={CustomPopper}
                           className='MuiAutocomplete-popper'
                           classes={{root: "MuiAutocomplete-popper"}}
                           id='field-type-autocomplete'
                           getOptionLabel={(option) => (option.subheader ? '' : option.title || '')}
                           getOptionDisabled={(option) => option.disabled}
                           onChange={(event, newValue) => {
                             // Only allow actual items (not subheaders) to be selected
                             if (newValue && !newValue.subheader) {
                               onChange(newValue?.value || '');
                             }
                           }}
                           value={
                             optionsWithSubheader.find(option => option.value == value) || null
                           }
                           disableClearable={true}
                           noOptionsText="No matching types available"
                           renderOption={(option) => {
                             if (option.subheader) {
                               return <ListSubheader disableSticky={true} style={{padding: 0, margin: 0}}>{option.title}</ListSubheader>;
                             }
                   
                             return (
                               <MenuItem key={option.value} style={{padding: 0, margin: 0}} value={option.value}>
                                 {option.tooltip ? (
                                   <Tooltip title={option.tooltip} placement="right">
                                     <span>{option.title}</span>
                                   </Tooltip>
                                 ) : (
                                   <span>{option.title}</span>
                                 )}
                               </MenuItem>
                             );
                           }}
                           renderInput={(params) => (
                             <TextField
                             name="type"
                               {...params}
                               label="Type"
                               variant="outlined"
                               required
                               error={Boolean(errors?.type)}
                               helperText={messages[errors?.type?.type] || ''}
                               fullWidth
                             />
                           )}
                         />
                       );
                     }}
                   />
                   
                   }
          </Grid>

         

          

           {/* Chekcbox for allowing multiline values for String and OctectString type */}
           {renderMultilineInputCheckbox &&
            <Grid item xs={12} style={{marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0}}>
                <Controller
                  name="allowMultiline"
                  control={control}
                  render={({ field, onChange }) => (
                    <FormControlLabel
                      style={{ color: '#8f8f8f' }} // Light grey label
                      control={
                        <Checkbox
                          {...field}
                          checked={allowMultiline}
                          onChange={(e) => {
                              onChange(e.target.checked)
                              setSelectedField(prev => ({ ...prev, attributes: { ...prev.attributes, allowMultiline: e.target.checked } }))
                              setAllowMultiline(e.target.checked)
                            }
                          } 
                          name="allowMultiline"
                          id="allowMultiline"
                          color="default" // Use default color for more control
                          style={{ color: '#8f8f8f' }} // Light grey checkbox
                        />
                      }
                      label="Support Multiple Lines"
                    />
                  )}
                />

                
            </Grid> }

          {renderIconType && (
            <Grid item xs={12}>
              <Controller
                name="iconType"
                control={control}
                defaultValue={icon !== undefined && icon !== '' ? icon : ''}
                render={({ field, value, onChange }) => (
                  <TextField
                    {...field}
                    name="iconType"
                    label={'Icon'}
                    select
                    fullWidth
                    variant={'outlined'}
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                    }}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {iconTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}



          {renderdropdownValue && (
            <Grid item xs={12}>
              <TextField
                id="dropdown"
                InputLabelProps={{
                  shrink: true,
                }}
                type={'text'}
                fullWidth
                rows={4}
                label={'Dropdown'}
                placeholder={'Dropdown'}
                variant="outlined"
                name="dropdown"
                inputRef={register({ required: false })}
                helperText={'Use comma seperated values for dropdown. Eg: "EEA:0, EEB:1"'}
              />
            </Grid>
          )}

          {renderCollectionValue && (
            <Grid item xs={12}>
              <Controller
                name="collection"
                control={control}
                defaultValue={false}
                render={({ field, value, onChange }) => (
                  <TextField
                    {...field}
                    name="collection"
                    label={'Collection'}
                    select
                    fullWidth
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={value}>
                    {/* <MenuItem key={123} value={""}>Select</MenuItem> */}
                    {booleanOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {renderDefaultValue && (
            <Grid item xs={12}>
              <TextField
                id="defaultVal"
                type={'text'}
                fullWidth
                label={'Default'}
                placeholder={'Default'}
                variant="outlined"
                name="defaultVal"
                InputLabelProps={{
                  shrink: true,
                }}
                inputRef={register({ required: false, validate: typeSpecificValidation(typeOfField) })}
              //error={errors?.defaultVal ? true : false}
              // helperText={messages[errors?.defaultVal?.type] && numberTypes.includes(typeOfField) ? 'This field must be integer or float' : messages[errors?.defaultVal?.type] ? 'This field must be integer/float/string' : ""}
              />
            </Grid>
          )}

          {renderDatePicker === true && (
            <Grid item xs={12}>
              <DateTimePickerField id="defaultDateVal" name="defaultDateVal" label="Default date(UTC)" handleDatePicker={handleChange} helperText={dateStatus ? 'Date is assumed to be UTC. Time will be assumed as 00:00:00' : 'Invalid date'} defaultDate={dateTimeCheck === true ? defaultVal : null} />
            </Grid>
          )}

          {renderBooleanDefaultValue && (
            <Grid item xs={12}>
              <Controller
                name="defaultBoolVal"
                control={control}
                // defaultValue={defaultVal}
                render={({ field, value, onChange }) => (
                  <TextField
                    {...field}
                    name="defaultBoolVal"
                    label={'Default'}
                    select
                    fullWidth
                    defaultValue={typeof defaultVal === 'boolean' ? defaultVal : false}
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}
                  // value={value}
                  >
                    {booleanOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {renderMinValue && (
            <Grid item xs={6}>
              <TextField
                id="minval"
                type={'text'}
                fullWidth
                rows={4}
                label={'Minimum Value'}
                placeholder={'Minimum Value'}
                variant="outlined"
                name="minval"
                inputRef={register({ required: false, validate: typeSpecificValidation(typeOfField) })}
                error={errors?.minval ? true : false}
                helperText={messages[errors?.minval?.type] && numberTypes.includes(typeOfField) ? 'This field must be integer or float' : messages[errors?.minval?.type] ? 'This field must be integer/float/string' : ''}
              />
            </Grid>
          )}

          {renderMaxValue && (
            <Grid item xs={6}>
              <TextField
                id="maxval"
                type={'text'}
                fullWidth
                rows={4}
                label={'Maximum Value'}
                placeholder={'Maximum Value'}
                variant="outlined"
                name="maxval"
                inputRef={register({ required: false, validate: typeSpecificValidation(typeOfField) })}
                error={errors?.maxval ? true : false}
                helperText={messages[errors?.maxval?.type] && numberTypes.includes(typeOfField) ? 'This field must be integer or float' : messages[errors?.maxval?.type] ? 'This field must be integer/float/string' : ''}
              />
            </Grid>
          )}

          {renderUnitValue && (
            <Grid item xs={12}>
              <TextField id="unit" type={'text'} fullWidth rows={4} label={'Unit'} placeholder={'Unit'} variant="outlined" name="unit" inputRef={register({ required: false })} />
            </Grid>
          )}

          {renderaxisValue && (
            <Grid item xs={12}>
              <Controller
                name="axis"
                control={control}
                render={({ field, onChange }) => (
                  <TextField
                    {...field}
                    name="axis"
                    label={'Axis'}
                    select
                    fullWidth
                    variant={'outlined'}
                    defaultValue={axis}
                    onChange={(e) => {
                      onChange(e);
                    }}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {axisOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {/* dimensions split into height and width(hXw)  */}
          {(renderDisplayTypes || renderControlTypes) && (
            <Grid item xs={6}>

              <Controller
                  name="width"
                  control={control}
                  defaultValue={''}
                  render={({ field, value, onChange }) =>
                      <TextField
                          {...field}
                          name="width"
                          label={'Width'}
                          select
                          fullWidth
                          variant={'outlined'}
                          value={value}
                          onChange={e => { onChange(e) }}
                      >
                          <MenuItem key={123} value={""}>Select</MenuItem>
                          {fieldDimensionOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                  {option.title}
                              </MenuItem>
                          ))}
                      </TextField>
                  }
              />
            </Grid>
          )}

          {(renderDisplayTypes || renderControlTypes) && (
            <Grid item xs={6}>
              <Controller
                name="height"
                control={control}
                defaultValue={''}
                render={({ field, value, onChange }) =>
                    <TextField
                        {...field}
                        name="height"
                        label={'Height'}
                        select
                        fullWidth
                        variant={'outlined'}
                        value={value}
                        onChange={e => { onChange(e) }}
                    >
                        <MenuItem key={123} value={""}>Select</MenuItem>
                        {fieldDimensionOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.title}
                            </MenuItem>
                        ))}
                    </TextField>
                }
              />
            </Grid>
          )}

          {renderOrientation && (
            <Grid item xs={12}>
              <Controller
                name="orientation"
                control={control}
                render={({ field, onChange }) => (
                  <TextField
                    {...field}
                    name="orientation"
                    label={'Orientation'}
                    select
                    fullWidth
                    variant={'outlined'}
                    defaultValue={orientation}
                    onChange={(e) => {
                      onChange(e);
                    }}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {orientationOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {renderStep && (
            <Grid item xs={12}>
              <TextField
                id="step"
                type={'text'}
                fullWidth
                rows={4}
                label={'Step'}
                placeholder={'Step'}
                variant="outlined"
                name="step"
                inputRef={register({ required: false, validate: integerFloatCheck })}
                error={errors?.step ? true : false}
                helperText={errors?.step ? 'This field must be integer or float' : ''}
              />
            </Grid>
          )}

          {renderValidationValue && (
            <Grid item xs={12}>
              <TextField
                id="validation"
                type={'text'}
                fullWidth
                rows={4}
                label={'Validation'}
                placeholder={'Validation'}
                variant="outlined"
                name="validation"
                inputRef={register({ required: false, ...patternOnly })}
                error={errors?.validation ? true : false}
                helperText={messages[errors?.validation?.type] ? 'This field cannot contain special characters or white spaces' : ''}
              />
            </Grid>
          )}

          {renderlineType && (
            <Grid item xs={12}>
              <Controller
                name="linetype"
                control={control}
                render={({ field, onChange }) => (
                  <TextField
                    {...field}
                    name="linetype"
                    label={'Line Type'}
                    select
                    fullWidth
                    variant={'outlined'}
                    defaultValue={linetype}
                    onChange={(e) => {
                      onChange(e);
                    }}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {lineTypeOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {rootElement === 'property' && profile == false && (
            <Grid item xs={12}>
              <Controller
                name="visible"
                control={control}
                render={({ field, onChange }) => (
                  <TextField
                    {...field}
                    name="visible"
                    label={'Visibility'}
                    defaultValue={visible}
                    select
                    fullWidth
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {booleanOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {/* Enable or disable hyperlink */}
          {renderHyperlink && profile == false && !isEventType && (
            <Grid item xs={12}>
              <Controller
                name="hyperlink"
                control={control}
                defaultValue={hyperlinkOptionValue}
                render={({ field, value, onChange }) => (
                  <TextField
                    {...field}
                    label={'Hyperlink'}
                    name="hyperlink"
                    select
                    fullWidth
                    required
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={value}>
                    {hyperlinkOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {/* Hyperlink types */}
          {renderHyperlink && hyperlinkOption == 'enable' && (
            <Grid item xs={12}>
              <Controller
                name="hyperlinkType"
                control={control}
                rules={{ required: true, requiredOnly }}
                defaultValue={hyperlinkTypeDefault}
                render={({ field, value, onChange }) => (
                  <TextField
                    {...field}
                    name="hyperlinkType"
                    label={'Hyperlink type'}
                    select
                    fullWidth
                    required
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={value}
                    error={errors?.hyperlinkType ? true : false}
                    helperText={errors?.hyperlinkType ? messages.required : ''}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {hyperlinkTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {/* View names list - Attribute for Url View */}
          {renderHyperlink && hyperlinkOption == 'enable' && selectedHyperlinkType == 'urlView' && (
            <Grid item xs={12}>
              <Controller
                name="viewname"
                control={control}
                rules={{ required: true, requiredOnly }}
                defaultValue={viewname != undefined ? viewname : ''}
                render={({ field, value, onChange }) => (
                  <TextField
                    {...field}
                    name="viewname"
                    label={'View name'}
                    select
                    fullWidth
                    required
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={value}
                    error={errors?.viewname ? true : false}
                    helperText={errors?.viewname ? messages.required : ''}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {viewsNames.map((view) => (
                      <MenuItem key={view._id} value={view._id}>
                        {view.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {/* Clusterlet types list - Attribute for Url Clusterlet */}
          {renderHyperlink && hyperlinkOption == 'enable' && selectedHyperlinkType == 'urlClusterlet' && (
            <Grid item xs={12}>
              <Controller
                name="clusterlettype"
                control={control}
                rules={{ required: true, requiredOnly }}
                defaultValue={clusterlettype != undefined ? clusterlettype : ''}
                render={({ field, value, onChange }) => (
                  <TextField
                    {...field}
                    name="clusterlettype"
                    label={'Clusterlet type'}
                    select
                    fullWidth
                    required
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    value={value}
                    error={errors?.clusterlettype ? true : false}
                    helperText={errors?.clusterlettype ? messages.required : ''}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {clusterletNames.map((item) => (
                      <MenuItem key={item._id} value={item._id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}


          {/* Transaction */}
          {renderControlTypes && typeOfField == "control-button" && (
            <>
              <Grid item xs={12}>
                <Controller
                  name="transaction"
                  control={control}
                  rules={{ required: true, requiredOnly }}
                  defaultValue={transaction}
                  render={({ field, value, onChange }) => (
                    <TextField
                      {...field}
                      name="transaction"
                      label={'Transaction'}
                      select
                      fullWidth
                      value={value}
                      required
                      variant={'outlined'}
                      onChange={(e) => {
                        onChange(e);
                      }}
                      error={errors?.transaction ? true : false}
                      helperText={messages[errors?.transaction?.type] || ''}>
                      <MenuItem key={123} value={''}>
                        Select
                      </MenuItem>
                      {transactions.map((option) => (
                        <MenuItem key={option._id} value={option._id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </Grid>

              <Grid xs={12} item>
                <TextField
                  name="instance"
                  fullWidth
                  type={'text'}
                  required={true}
                  label={'Instance'}
                  defaultValue={instance != undefined ? instance : ''}
                  variant="outlined"
                  placeholder={'Instance'}
                  inputRef={register({ ...basicFolderFileName })}
                  error={errors?.instance ? true : false}
                  helperText={errors?.instance ? messages["required"] : ""}
                />
              </Grid>

            </>

          )}

          {/* Instance */}
          {renderHyperlink && hyperlinkOption == 'enable' && (selectedHyperlinkType == 'urlView' || selectedHyperlinkType == 'urlClusterlet') && (
            <Grid xs={12} item>
              <TextField
                name="instance"
                fullWidth
                type={'text'}
                required={true}
                label={'Instance'}
                defaultValue={instance != undefined ? instance : ''}
                variant="outlined"
                placeholder={'Instance'}
                inputRef={register({ ...basicFolderFileName })}
                error={errors?.instance ? true : false}
                helperText={errors?.instance ? messages["required"] : ""}
              />
            </Grid>
          )}

          {/* Url - Attribute for external url  */}
          {renderHyperlink && hyperlinkOption == 'enable' && selectedHyperlinkType == 'urlExternal' && (
            <Grid xs={12} item>
              <TextField name="url" fullWidth type={'text'} required={true} label={'Url'} defaultValue={url != undefined ? url : ''} variant="outlined" placeholder={'Url'} inputRef={register({ ...requiredOnly })} error={errors?.url ? true : false} helperText={errors?.url ? messages?.required : ''} />
            </Grid>
          )}

          {renderOptionalValue && !isEventType && (
            <Grid item xs={12}>
              <Controller
                name="optional"
                control={control}
                render={({ field, onChange }) => (
                  <TextField
                    {...field}
                    name="optional"
                    label={'Optional'}
                    select
                    fullWidth
                    variant={'outlined'}
                    onChange={(e) => {
                      onChange(e);
                    }}
                    defaultValue={optional}>
                    <MenuItem key={123} value={''}>
                      Select
                    </MenuItem>
                    {booleanOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.title}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {/* Constriants for message fields */}
          {renderConstraint && <Grid item xs={12}>
              <TextField
                  id="constraint"
                  type={"text"}
                  fullWidth
                  label={"Constraint"}
                  placeholder={"Contraint"}
                  variant="outlined"
                  name="constraint"
                  inputRef={register({ required: false })}
                  helperText={'Use comma seperated values for constraints or specify a range of values. Eg: "value1,value2" or "-10..10,20..30"'}
              />
          </Grid>}

          {renderColorPicker && <>
                    <Grid item xs={6}>
                        <TextField
                            id="textColor"
                            label="Text Color"
                            type="text"
                            name="textColor"
                            value={textcolor}
                            onChange={handleTextcolorChange}
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <input
                                    type="color"
                                    value={textcolor}
                                    onChange={handleTextcolorChange}
                                    style={{cursor: 'pointer',width: '30px',height: '30px',border: 'none',padding: 0,background: 'none'}}
                                    />
                                </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} style={{marginBottom: '10px'}}>
                        <TextField
                            id="backgroundColor"
                            label="Background Color"
                            name="backgroundColor"
                            type="text"
                            value={bgcolor}
                            onChange={e=> handleBgcolorChange(e)}
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                    <input
                                    type="color"
                                    value={bgcolor}
                                    onChange={e=> handleBgcolorChange(e)}
                                    style={{cursor: 'pointer',width: '30px',height: '30px',border: 'none',padding: 0,background: 'none'}}
                                    />
                                </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                </>}

          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
            <UpdateCancel onUpdate={handleSubmit(onUpdate)} updateDisable={loading} content={loading ? 'Updating' : 'Update'} onCancel={onClose} typesNotIn={['transaction', 'view']} />
          </Grid>
        </Grid>
      )}
    </>
  );
}


function CustomPopper(props) {
  return <Popper {...props} id="type-autocomplete-popper" />;
}